export default __webpack_public_path__ + "static/media/baby-6.115e271d.svg";